import { useTranslation } from "react-i18next";
import useApp from "../../hooks/useApp";
import CountDownTimer from "../CountDownTimer";
import "./styles.scss";

const ResendOTP = ({ showCountdownTimer, setShowCountdownTimer }) => {
  const { t } = useTranslation();
  const { isRTL, tenantConfig } = useApp();

  return (
    <div className="resend-otp-container">
      <span className={`resend-text ${isRTL ? "resend-text-rtl" : ""}`}>
        {showCountdownTimer
          ? t("verificationCode.footer_text2")
          : t("verificationCode.footer_text1")}
      </span>
      {showCountdownTimer ? (
        <CountDownTimer
          initialSeconds={
            tenantConfig?.otp_setting.content.retry_policy
              .retry_delay_in_seconds
          }
          onCountdownEnd={() => setShowCountdownTimer(false)}
        />
      ) : (
        <span
          className="resend-link"
          onClick={() => setShowCountdownTimer(true)}
        >
          {t("verificationCode.resend")}
        </span>
      )}
    </div>
  );
};

export default ResendOTP;
